import React, { Component } from 'react';
// import "./ConversationSearch.css";
import { ChevronLeft, CloseRounded } from '@mui/icons-material';
import Api from '../../customlib/Api';
import Global from '../../customlib/Global';
import axios from 'axios';
import ConversationListItem from '../ConversationListItem';
import { CircularProgress, TextField, Tooltip, Paper, FormControlLabel, Switch, List, ListItem, Chip, ListItemAvatar, Avatar, ListItemText, Grid, Typography, Box, Button, LinearProgress } from '@mui/material';

class InboxDibacaBelumRespon extends Component {
  state = {
    listMycustomer: [],
    page: 0,
    rowsPerPage: 30,
    keyword: "",
    useLimit: false,
    isLoading: false,
    searchInMessages: false,
    searchInField: "fromName"
  }

  handleKeyword = (event) => {
    this.setState({ keyword: event.target.value });
  };

  onKeyDownHandler = e => {
    if (e.keyCode === 13) {
      this.getMyCustomerToday();
    }
  };

  getMyCustomerToday = () => {

    this.setState({isLoading: true}, () => {
      var userData = Global.get();
      const params = {
          userId: userData.user.id,
          appProfileId: Global.getSwitchAppProfile()._id,
      }

      console.log("PARAMS", params);

      axios
      .post(Api.getListJustReadMessage(), params, Api.getRequestHeader())
      .then((response) => {
          console.log("MyCustomerToday : ", response.data);
          var customers = response.data.data;
          customers.forEach(customer => {
            customer.contact = Global.generateItemConversation(customer);
          });

          this.setState({listMycustomer: customers, isLoading: false});
      })
      .catch((error) => {
        this.setState({isLoading: false});
        console.error("There was an error!", userData.user.id, error);
      });
    });

  };

  handleSwitchSearchContext = () => {
    let mode = false;
    if(this.state.searchInMessages === true){
      mode = false;
    }else{
      mode = true;
    }

    this.setState({searchInMessages: mode, keyword: this.state.keyword}, () => {
      this.getMyCustomerToday();
      // this.getCsHelpList();
    });

  }

  getFieldClassName = (fieldName) => {
    let className = "badge";
    if(this.state.searchInField === fieldName){
      className += " badge-primary";
    }else{
      className += " badge-secondary";
    }

    return className;
  }

  handleFieldSelectionChanged = (fieldName) => {
    this.setState({searchInField: fieldName}, () => {
      this.getMyCustomerToday();
    });
  }

  componentDidMount() {
    this.getMyCustomerToday();
  }

  render() { 
    return ( 

      <Paper style={{marginTop: 10, marginLeft: 5, marginRight: 5, marginBottom: 20}}>
        <Box>
          <Box textAlign={this.props.isMobile ? "left" : "right"}>
          {
              this.props.isMobile && (
                <Box>
                  <Grid container spacing={1}>
                    <Grid xs={1} item>
                      <ChevronLeft onClick={this.props.onClose} className="" style={{cursor: "pointer"}}/>
                    </Grid>
                    <Grid xs={11} item>
                      <Typography variant="h6" gutterBottom component="div">
                          Inbox Dibaca Belum Direspon
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              )
          }
          
          {
              !this.props.isMobile && (
              <Grid container spacing={1}>
                <Grid item xs={10}>
                  <Box sx={{ml: "8px", fontWeight: "bold", textAlign: "left"}}>
                    {Global.getSwitchAppProfile().label}
                  </Box>
                </Grid>
                <Grid item xs={2}>
                  <Tooltip title="Akhiri pencarian">
                    <CloseRounded onClick={this.props.onClose} className="text-danger" style={{cursor: "pointer"}}/>
                  </Tooltip>
                </Grid>
              </Grid>)
            }
          </Box>
        </Box>
        <Box sx={{padding: "10px"}}>
          <Button fullWidth size='small' variant='contained' color='primary' onClick={this.getMyCustomerToday}>Reload</Button>
        </Box>
        {
          this.state.isLoading === true ? 
          (
            <LinearProgress />
          ) : (<></>)
        }

        <Box>
          {/* {
            !this.props.isMobile && this.state.listMycustomer.map((conversation) => {
              
              return (
                <ConversationListItem
                  onSelect={this.props.onSelect}
                  key={this.state.searchInMessages === true ? conversation.contactId : conversation.fromNumber}
                  data={conversation}
                />
              )
                    
              })
          } */}

          {
            (this.props.isMobile === true) && (
              <List>
              {
                  this.state.listMycustomer.map(
                      conversation => (
                          <ListItem key={`conv-item-${conversation.from}`}
                              secondaryAction={
                                  <Box edge="end" aria-label="delete" sx={{textAlign: "center"}}>
                                      <Box textAlign={"center"} fontSize={"13px"}>
                                        {conversation.delta}
                                          {/* <Chip label={conversation.delta} variant='contained' /> */}
                                      </Box>
                                  </Box>
                              }
                              color='warning'
                              sx={{backgroundColor: "#FFFFFF98", mb: "8px"}}
                              onClick={() => this.props.onSelect(conversation)}
                          >
                              <ListItemAvatar>
                                  <Avatar src='aaa.jpg' alt={conversation.fromName} sx={{bgcolor: "#651fff"}}>
                                      
                                      {/* <ImageIcon /> */}
                                  </Avatar>
                              </ListItemAvatar>
                              <ListItemText primary={<strong>{conversation.fromName}</strong>} 
                                secondary={
                                  <Box>
                                    {conversation.assignToUserName} - {Global.maskPhoneNumber(conversation.from)}
                                    {/* <Chip label={conversation.assignToUserName} variant='outlined' />
                                    <Chip label={Global.maskPhoneNumber(conversation.from)} variant='outlined' /> */}
                                  </Box>
                                } 
                              />
                          </ListItem>
                      )
                  )
              }
          </List>
            )
          }
        </Box>
        
      </Paper>
    );
  }
}
 
export default InboxDibacaBelumRespon;